
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ca3e6203218d025313f051f66cb04a51.jpg"
          alt="مشروع أمني متكامل"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/88 via-navy/80 to-navy/88"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10 text-center w-full">
        {/* Icon */}
        <div className="w-24 h-24 flex items-center justify-center rounded-full bg-primary mx-auto mb-8 shadow-2xl">
          <i className="ri-shield-check-line text-5xl text-white"></i>
        </div>

        {/* Heading */}
        <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight tracking-wide">
          جاهزون لحماية منشأتك؟
        </h2>

        {/* Subheading */}
        <p className="text-xl text-silver mb-10 max-w-3xl mx-auto">
          احصل على استشارة مجانية وعرض سعر مفصل خلال 24 ساعة من فريق الخبراء لدينا
        </p>

        {/* CTA Button */}
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 px-12 py-5 bg-primary text-white text-lg font-bold rounded-xl hover:bg-primary-dark transition-all duration-300 shadow-2xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
        >
          <span>اطلب عرضك المجاني الآن</span>
          <i className="ri-arrow-left-line text-xl"></i>
        </Link>

        {/* Additional Info */}
        <div className="flex flex-wrap items-center justify-center gap-8 mt-12">
          {[
            { icon: 'ri-phone-line', text: 'استجابة سريعة خلال ساعات' },
            { icon: 'ri-shield-check-line', text: 'ضمان على جميع الأنظمة' },
            { icon: 'ri-customer-service-2-line', text: 'دعم فني 24/7' },
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-3 text-white/90">
              <i className={`${item.icon} text-2xl text-primary`}></i>
              <span className="text-base">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
